/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(window).on('load',function(){
    $('#Search[aria-hidden="true"] .aa-Input[type="search"]').attr("autofocus",true);
    $('[data-action="toggle-search"]').on('click',function(){
    setTimeout(function(){
        $('#Search[aria-hidden="false"] .aa-Input[type="search"]').click().focus();
    }, 500);
    })
});

var interval;
var  klarnaIsReady = false;
var  tabsClosed = false;

// interval = setInterval(function(){
//   if(klarnaIsReady == false){
    //    klarnaStyle();
//   }else{
    // clearInterval(interval);
//   }
// },500);
function removeReviewsWords(){
    let yotpoIsReadyPfs = false;

  (function checkForYotpo() {
      setTimeout(function () {
          if (typeof yotpo !== "undefined") {
              if (yotpo.initialized === true) {
                $(".yotpo.bottomLine").each(function(item){
                  let textm = $(this).find(".text-m");
                  if ($(this).find(".text-m").length){
                    // if (item != undefined && textm.text() != undefined) {
                      yotpoIsReadyPfs = true;
                      let textmVal = textm.text();
                      if (textmVal != "Write a review") {
                        // $(this).find(".text-m").text(textmVal.replace(/(?<=\S)\s\S+/, ''));
                        $(this).find(".text-m").text(textmVal.replace(/\s*Review(s)?/g, ''));
                        $(this).find(".text-m").show(); 
                      }
                //   }
                }
                });
              }
          }
          if (yotpoIsReadyPfs === false) checkForYotpo();
      }, 3500)
  })(); 
}

function klarnaStyle(){

  if(document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector("div > div") != null){

    klarnaIsReady = true;
    $('.ProductMeta__PriceList').append($('[data-key="credit-promotion-badge"]'));
    document.querySelector("[data-key='credit-promotion-badge']").style.display = 'none';

    var _style = {
        border: "none",
        padding: "15px 0"
    };

    var klarna = document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector("div > div");

    if ($(window).width() < 641) {
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector(".badge").style.width = '55px';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector("div > div > div button").style.fontSize = '14px';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector("div > div > div p").style.fontSize = '14px';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector(".container").style.justifyContent = 'left';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector(".badge > svg > g > path:nth-child(1)").style.fill = '#000000';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector(".badge > svg > g > path:nth-child(2)").style.fill = '#ffffff';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector(".text-wrapper > p").style.fontSize = '10px';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector(".text-wrapper > p").style.textTransform = 'capitalize';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector(".text-wrapper > p").style.fontWeight = '500';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector(".text-wrapper > p").style.lineHeight = '1.1em';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector("button").style.fontSize = '10px';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector("button").style.textTransform = 'capitalize';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector("button").style.display = 'block';
    } else {
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector("div > div > div button").style.fontSize = '14px';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector("div > div > div p").style.fontSize = '14px';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector(".badge").style.width = '55px';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector(".badge > svg > g > path:nth-child(1)").style.fill = '#000000';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector(".badge > svg > g > path:nth-child(2)").style.fill = '#ffffff';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector(".text-wrapper > p").style.fontSize = '10px';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector(".text-wrapper > p").style.textTransform = 'capitalize';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector(".text-wrapper > p").style.fontWeight = '500';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector(".text-wrapper > p").style.lineHeight = '1.1em';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector("button").style.fontSize = '10px';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector("button").style.textTransform = 'capitalize';
        document.querySelector("[data-key='credit-promotion-badge'] > div").shadowRoot.querySelector("button").style.display = 'block';
    }
   Object.assign(klarna.style, _style);
    document.querySelector("[data-key='credit-promotion-badge']").style.display = 'block';
  }
};

$(document).on('click', '.close-dialog', function () {

    $('.icons-shade-background').remove();
});

$(document).on('click', '.learn-more', function () {
    var text = $(this).find('.full-text').html().trim();
    var image = $(this).find('.icon').html();
    var title = $(this).find('.title span').html();
    $('body').append(`
                <div style="opacity:0" class="icons-shade-background close-dialog">
                    <div class="icons-dialog">
                         <div class="icons-learn-more-wrapper">
                             <div class="icons-learn-more-dialog">
                                <div class="icons-close-cross close-dialog"><svg aria-hidden="true" focusable="false" role="img" height="20" width="20"><g transform="translate(0, 0) scale(1)"><path d="M10.872 10.004c.449-.14.875-.373 1.23-.729l5.602-5.601L16.29 2.26l-5.602 5.601a.999.999 0 01-1.414 0l-5.57-5.57L2.29 3.705l5.57 5.57c.364.364.8.6 1.261.738a2.86 2.86 0 00-1.229.708L2.29 16.322l1.414 1.414 5.603-5.601a1.022 1.022 0 011.413 0l5.57 5.57 1.414-1.414-5.57-5.57a2.869 2.869 0 00-1.262-.717z" fill="rgba(14, 14, 15, 1)" style="transition: fill 0.2s ease 0s;"></path></g></svg></div>
                                ${image}
                                <div class="learn-more-title">${title}</div>
                                ${text}
                                <div class="icons-close-btn close-dialog">CLOSE</div>
                            </div>
                        </div>
                    </div>
                </div>`);
    setTimeout(function () {
        $('.icons-shade-background').css('opacity', 1);
    }, 300);
});


$(document).on('click', '.option_selector-label', function () {
    var id = $(this).parent().parent().parent().attr('id');
    $(this).prev().click();
    //var parent = $(this).parent().attr('id');
    //$('#'+parent+' .option_selector-label').removeClass('selected');
    //$(this).addClass('selected');
    updateMaster(getVariantOptions(id), id);

});

function getVariantOptions(containerID) {
    var selected = '';
    $.each($('#' + containerID + ' .option_selector:checked'), function (key, item) {
        selected += $(item).val();
        selected += ' / ';
    });
    return selected.slice(0, -3);
}

function getVariantsFromMaster(id) {
    if (!$('#VariantMaster-quick-' + id).hasClass('opened')) {
        var valuesArray = $('#VariantMaster-quick-' + id).val().split(' / ');
        $.each(valuesArray, function (key, item) {
            $('[data-value="' + item + '"]').click();
        });
        $('#VariantMaster-quick-' + id).change();
        $('#VariantMaster-quick-' + id).addClass('opened');
    }
}


function updateMaster(options, id) {
    if ($('#VariantMaster-' + id).find('[data-option="' + options + '"]').attr('disabled') === 'disabled') {
        $('#' + id).find('.qatc-btn').addClass('disabled').text('Not available');
    } else {
        $('#' + id).find('.qatc-btn').removeClass('disabled');
        $('#VariantMaster-' + id).val(options);
        $('#VariantMaster-' + id).change();
        $('#' + id + ' .qatc-btn').text('Add to Cart');
    }
}

$(document).on('click', '.quick-atc-icon', function (event) {
    event.preventDefault();
    var id = $(this).attr('product-id');
    openQuickAddToCart(id);
});

function openQuickAddToCart(id) {
    var option = $('#VariantMaster-quick-' + id + ' option:selected').val();
    var variant_id = $('#VariantMaster-quick-' + id + ' option:selected').attr('variant-id');
    var url_link = $('#atc-icon-' + id).parent().parent().attr('href');

    if (variant_id === undefined) {
        window.location.href = url_link;
    } else {
        if (option === 'Default Title') {
            addVariantToCart(variant_id);
        } else {
            $('#quick-' + id).slideDown(300);
            $('.quick-atc-modal-backdrop').show().addClass('active');
            getVariantsFromMaster(id);

        }
    }
}
$(document).on('click', '.quick-atc-modal-backdrop', function () {
    $(this).hide().removeClass('active');
    $('.quick-add-to-cart').slideUp(300);

});

function addVariantToCart(variant_id) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: parseInt(variant_id),
            quantity: 1
        })
    })
        .then(function (response) {
            //return response.json();
        })
        .then(function (cart) {
            // Do something with the updated cart
            sellify.ucd.helpers.ajaxCart.load();
            setTimeout(function () {
                $('.quick-atc-modal-backdrop').hide().removeClass('active');
                $('.quick-add-to-cart').slideUp(500);

            }, 100);

        });
}

$(document).on('click', '.qatc-btn', function () {
    //var container = $(this).parent();
    var _this = $(this);
    var _product_id = $(this).attr('product-id');
    var _variant_id = $('#VariantMaster-quick-' + _product_id + ' option:selected').attr('variant-id');
    addVariantToCart(_variant_id);
});

function deleteCookie(cookieName) {
    document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

var len = $('.additional-checkout-buttons').length;
var appleBtn = $('[data-testid="ApplePay-button"]').length;
window.addEventListener('Sellify::UCD::RecommendedProductsRendered', function (e) {
    var intervalTimes = 0;
    buttonsAreReady = false;
    interval = setInterval(function(){
    if (buttonsAreReady == false && intervalTimes <= 20) {
        checkApplePay();
        deleteCookie("dynamic_checkout_shown_on_cart");
        intervalTimes++;
    } else {
        clearInterval(interval);
    }
    },500);
});
function checkApplePay(){
    if( !$('#dynamic-checkout-cart').is(':empty') ) {
        buttonsAreReady = true;
        if (len > 0 && $('[data-testid="ApplePay-button"]').length > 0) {
            $('.apple-pay-btn').css('display', 'flex');
            $('#sellify-ucd-cart-drawer.ucd-sticky-subtotal.ucd-sticky-checkout-btn .ucdcart__footer').css('bottom','139px');
        } else {
            $('.apple-pay-btn').css('display', 'none');
        }
    }
}

$(document).on('click', '.apple-pay-btn', function () {
    if (typeof gtag === "function") { 
      gtag("event", "begin_checkout_apple_pay", { 
        "event_category": "Button", 
        "event_label": "Apple Pay Sidecart" }); 
      } 
    $('[data-testid="ApplePay-button"]').click();
});

window.addEventListener('load', () => {
    removeReviewsWords();
    const sortButton = document.querySelector('#sort-button');
    const sortOptions = document.querySelector('#sort-options');
    
    // Add event listener to toggle dropdown visibility on button click
    sortButton?.addEventListener('click', function() {
      if (sortOptions.style.display === 'none') {
        sortOptions.style.display = 'block';
      } else {
        sortOptions.style.display = 'none';
      }
    });
    
    // Add event listener to update the selected option on list item click
    sortOptions.addEventListener('click', function(event) {
      const option = event.target.closest('li[data-value]');
      if (option) {
        const value = option.getAttribute('data-value');
        const selectElement = document.querySelector('.ais-SortBy-select');
        selectElement.value = value;
        selectElement.dispatchEvent(new Event('change'));
        sortOptions.style.display = 'none';
      }
    });
    

    document.addEventListener('click', function(event) {
        const isClickInsideSortButton = sortButton.contains(event.target);
        const isClickInsideSortOptions = sortOptions.contains(event.target);
        if (!isClickInsideSortButton && !isClickInsideSortOptions) {
          sortOptions.style.display = 'none';
        }
      });
  

    // Add event listeners to all slider headers
    document.querySelectorAll('.ais-range-slider--header').forEach(header => {
        // When a slider header is clicked
        header.addEventListener('click', function() {
            // Toggle the label icon between + and -
            const iconSpan = header.querySelector('.label_icon');
            iconSpan.textContent = iconSpan.textContent === '+' ? '-' : '+';
            iconSpan.style.fontSize = iconSpan.textContent === '-' ? '40px' : '23px';
        });
    });

    // Add a checkbox span to all refinement list items
    setInterval(() => {
        document.querySelectorAll('.ais-RefinementList-item').forEach(item => {
            // Check if a checkbox span has already been added to this refinement item
            if (!item.querySelector('.ais-RefinementList-checkbox')) {
                // Create and add the checkbox span
                const checkbox = document.createElement('span');
                checkbox.classList.add('ais-RefinementList-checkbox');
                item.insertBefore(checkbox, item.firstChild);

                // If the refinement item is selected, mark the checkbox as checked
                if (item.classList.contains('ais-RefinementList-item--selected')) {
                    checkbox.classList.add('ais-RefinementList-checkbox--checked');
                }
            }
        });

        // Extract and display the review count from all review elements
        // document.querySelectorAll('.text-m').forEach(element => {
        //     const reviewCount = element.innerText.match(/\d+/)[0];
        //     element.innerText = reviewCount;
        // });

        // // Remove decimal numbers from all child elements of .ais-hit--price elements
        // document.querySelectorAll('.ais-hit--price > *').forEach(priceElement => {
        //     priceElement.textContent = priceElement.textContent.replace(/\.\d+$/, '');
        // });
        // document.querySelectorAll('.aa-ItemContentPrice > *').forEach(priceElementSearch => {
        //     priceElementSearch.textContent = priceElementSearch.textContent.replace(/\.\d+$/, '');
        // });

    }, 50);
});